<div class="container-table">
  <mat-table
    #table
    class="table table-p1 borderless align-middle"
    matSortDisableClear
    [dataSource]="dataSource"
    matSort
    matSortDirection="desc"
  >
    <ng-container matColumnDef="user">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Usuário</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Usuário: </span>
        <span class="label-desktop label-data">
          {{ row?.changeBy || "N/A" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Data/Hora</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Data/Hora: </span>
        <div class="date-info">
          <span class="label-desktop label-data">
            {{ row?.changeDate | date : "dd/MM/yyyy HH:mm:ss" || "N/A" }}
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: displayedColumns">
    </mat-row>
  </mat-table>
</div>

<mat-paginator
  class="custom-paginator"
  [pageIndex]="pageNumber"
  [pageSize]="pageSize"
  [length]="totalElements"
  (page)="chanePageEvent($event)"
  [pageSizeOptions]="[5, 10, 25, 100]"
  showFirstLastButtons
></mat-paginator>
